export const DIGITAIN_COMPANY_ID = "a57ce327d81b4bc589f54930a9a8c064";